export default [
  {
    key: 'avatar.missing',
    icon: 'mdi-account-circle',
    name: 'Missing profile picture',
    description: 'Send a request to the candidate to upload a new / rectified photo',
    tooltip: 'Updated profile picture requested',
  },
  {
    key: 'biography.outdated',
    icon: 'mdi-account-clock-outline',
    name: 'Outdated bio',
    description: 'Send a request to the candidate to ensure their biography is up to date',
    tooltip: 'Biography update requested',
  },
  {
    key: 'financial_survey.dependents_incorrect',
    icon: 'mdi-cash-usd',
    name: 'Number of dependents excludes salary earner',
    description: 'Send a request to the candidate to change number of dependents to include the salary earner',
    tooltip: 'Dependent adjustment has been requested',
  },
  {
    key: 'household_income.inaccurate',
    icon: 'mdi-cash-usd',
    name: 'Household income not matching supporting documentation',
    description: 'Send a request to the candidate to update income figures as per the supporting documentation',
    tooltip: 'Income figure update has been requested',
  },
  {
    key: 'household_income.incorrect',
    icon: 'mdi-cash-usd',
    name: 'Household income figure expressed as net instead of gross',
    description: 'Send a request to the candidate to change income figure from net to gross',
    tooltip: 'Income figure correction has been requested',
  },
  {
    key: 'household_income.incorrect_proof',
    icon: 'mdi-file-alert',
    name: 'Incorrect proof of income document',
    description: 'Send a request to the candidate to replace the document with a more appropriate proof of income',
    tooltip: 'A replacement proof of income has been requested',
  },
  {
    key: 'household_income.outdated_proof',
    icon: 'mdi-file-refresh',
    name: 'Proof of income document outdated',
    description: "Send a request to the candidate to update the associated document",
    tooltip: 'Updated document has been requested',
  },
  {
    key: 'identity_document.incorrect',
    icon: 'mdi-file-alert',
    name: 'Incorrect identity document',
    description: 'Send a request to the candidate to upload a new/rectified document',
    tooltip: 'A new/rectified document has been requested',
  },
  {
    key: 'identity_document.low_quality',
    icon: 'mdi-file-alert',
    name: 'Low quality identity document',
    description: 'Send a request to the candidate to upload a new/rectified document',
    tooltip: 'A new/rectified document has been requested',
  },
  {
    key: 'grade_value.misrepresented',
    icon: 'mdi-school',
    name: 'Misrepresented grade',
    description: 'Send a request to the candidate to ensure that the captured grade matches the results on their academic transcript',
    tooltip: 'Grade correction has been requested',
  },
  {
    key: 'proof_of_registration.incorrect',
    icon: 'mdi-file-alert',
    name: 'Incorrect proof of registration',
    description: 'Send a request to the candidate to upload an appropriate proof of registration',
    tooltip: 'A new / rectified document has been requested',
  },
  {
    key: 'qualification_dates.incorrect',
    icon: 'mdi-calendar-remove',
    name: 'Qualification date(s) incorrect',
    description: 'Send a request to the candidate to ensure that the start date and/or completion date of the listed qualification matches their academic transcript',
    tooltip: 'Date correction has been requested',
  },
  {
    key: 'qualification.transcript_mismatch',
    icon: 'mdi-school',
    name: 'Qualification vs transcript mismatch',
    description: 'Send a request to the candidate to update the profile qualification to match the transcript',
    tooltip: 'Qualification details do not match transcript; update requested',
  },
  {
    key: 'transcript.grade_11',
    icon: 'mdi-file-alert',
    name: 'Request Grade 11 results',
    description: 'Send a request to the candidate to upload their final Grade 11 results in lieu of Grade 12 results',
    tooltip: 'Grade 11 results requested',
  },
  {
    key: 'transcript.incomplete',
    icon: 'mdi-file-alert',
    name: 'Full academic transcript required',
    description: 'Send a request to the candidate to provide a full academic transcript and not only a progress report or proof of registration',
    tooltip: 'Full academic transcript requested',
  },
  {
    key: 'transcript.low_quality',
    icon: 'mdi-file-alert',
    name: 'Low quality transcript',
    description: 'Send a request to the candidate to upload a clearer transcript',
    tooltip: 'A new / rectified document has been requested',
  },
  {
    key: 'transcript.outdated',
    icon: 'mdi-file-alert',
    name: 'Outdated transcript',
    description: 'Send a request to the candidate to upload their latest transcript',
    tooltip: 'Latest transcript has been requested',
  },
  {
    key: 'transcript.unreadable',
    icon: 'mdi-file-alert',
    name: 'Unreadable transcript',
    description: 'Send a request to the candidate to upload a readable transcript',
    tooltip: 'Replacement of password protected or unreadable transcript has been requested',
  },
]
